import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Flex, Form, Input, Modal, Steps } from "antd";
import Upload from "@/components/Upload";
import templateStore from "@/store/templateStore";
import { GetLocalStorage } from "@/utils/helper";
import PublicTet from "@/page/PublicTemplates/Tet";
import type { ICusTemplate } from "@/store/interface/template";

const FormTet = ({ initialData }: { initialData?: ICusTemplate }) => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewConfig, setPreviewConfig] = useState<any>({});
  const { saveConfig, updateConfig } = templateStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (initialData) form.setFieldsValue(initialData.config);
  }, []);

  const handlePreview = () => {
    setPreviewConfig(form.getFieldsValue());
    setPreviewOpen(true);
  };

  const steps = [{ title: "Bước 1" }, { title: "Bước 2" }, { title: "Bước 3" }];

  const stepContent = [
    // Step 1 — Thông tin chúc Tết
    <>
      <Form.Item name="avatar" label="Ảnh đại diện">
        <Upload maxSize={10} />
      </Form.Item>
      <Form.Item name="sender_name" label="Tên người gửi">
        <Input placeholder="Nhập tên người gửi lời chúc" />
      </Form.Item>
      <Form.Item name="receiver_name" label="Tên người nhận">
        <Input placeholder="Nhập tên người nhận (tuỳ chọn)" />
      </Form.Item>
      <Form.Item name="background" label="Ảnh nền">
        <Upload maxSize={10} />
      </Form.Item>
      <Form.Item name="greeting" label="Lời chúc Tết">
        <Input placeholder="VD: Chúc Mừng Năm Mới, An Khang Thịnh Vượng..." />
      </Form.Item>
      <Form.Item name="message" label="Lời nhắn nhủ">
        <Input.TextArea placeholder="Viết lời nhắn chúc Tết..." rows={4} />
      </Form.Item>
      <Form.Item name="year_label" label="Năm mới (tuỳ chọn)">
        <Input placeholder="VD: Ất Tỵ 2025, Bính Ngọ 2026..." />
      </Form.Item>
    </>,
    // Step 2 — Video chúc Tết
    <>
      <Form.Item name="video" label="Video chúc Tết">
        <Upload type="video" maxSize={10} />
      </Form.Item>
    </>,
    // Step 3 — Ảnh kỷ niệm Tết
    <>
      <Form.Item name="list_image" label="Ảnh kỷ niệm Tết">
        <Upload multiple maxSize={10} />
      </Form.Item>
    </>,
  ];

  const next = () => setCurrentStep(currentStep + 1);
  const prev = () => setCurrentStep(currentStep - 1);

  const handleFinish = async (value: any) => {
    try {
      let result;
      if (initialData) {
        result = await updateConfig(initialData.xid, { config: { ...value } });
      } else {
        const serial = await GetLocalStorage("scan-storage", "serial");
        result = await saveConfig({ type: "tet", chip_serial: serial, config: { ...value } });
      }
      if (result) navigate("/");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <section className="container">
      <Steps responsive={false} type="dot" titlePlacement="vertical" current={currentStep} items={steps} />

      <Form form={form} layout="vertical" style={{ marginTop: 24 }} onFinish={handleFinish} preserve>
        {stepContent.map((content, index) => (
          <div key={index} style={{ display: index === currentStep ? "block" : "none" }}>
            {content}
          </div>
        ))}

        <Flex className="mt-3">
          {currentStep > 0 && (
            <Button style={{ marginRight: 8 }} onClick={prev} className="w-full">
              Quay lại
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={next} className="w-full">
              Tiếp theo
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <>
              <Button onClick={handlePreview} style={{ marginRight: 8 }} className="w-full">
                Xem trước
              </Button>
              <Button type="primary" htmlType="submit" className="w-full">
                Hoàn thành
              </Button>
            </>
          )}
        </Flex>
      </Form>

      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={null}
        title="Xem trước"
        width={480}
        style={{ top: 8 }}
        styles={{ body: { padding: 0, height: "calc(100vh - 110px)", overflow: "auto" } }}
      >
        <PublicTet config={previewConfig} />
      </Modal>
    </section>
  );
};

export default FormTet;
